export default "__VITE_ASSET__CpK8RDaJ__"